import React, { useEffect } from 'react';
import { Drawer, Form, Input, Button, Space } from 'antd';

import {
    NutrigenUpcLink,
    AddNutrigenUpcLinkDto,
    UpdateNutrigenUpcLinkDto
} from '../../types/nutrigentypes';
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import CancelButton from '../common/cancelbutton';
import FormButton from '../common/formbutton';

interface NutrigenUpcLinkDrawerProps {
    open: boolean;
    loading: boolean;
    record?: NutrigenUpcLink | null;
    onClose: () => void;
    onAdd: (dto: AddNutrigenUpcLinkDto) => Promise<void>;
    onUpdate: (upc: string, dto: UpdateNutrigenUpcLinkDto) => Promise<void>;
}

const NutrigenUpcLinkDrawer: React.FC<NutrigenUpcLinkDrawerProps> = ({
    open,
    loading,
    record,
    onClose,
    onAdd,
    onUpdate
}) => {
    const [form] = Form.useForm();

    const isEdit = !!record;

    useEffect(() => {
        if (record) {
            form.setFieldsValue({
                upc: record.upc,
                nutrigenItemNum: record.nutrigenItenNum
            });
        } else {
            form.resetFields();
        }
    }, [record, form]);

    const handleSave = async () => {
        const values = await form.validateFields();

        if (isEdit && record) {
            const updateDto: UpdateNutrigenUpcLinkDto = {
                nutrigenItemNum: values.nutrigenItemNum
            };

            await onUpdate(record.upc, updateDto);
        } else {
            const addDto: AddNutrigenUpcLinkDto = {
                upc: values.upc,
                nutrigenItemNum: values.nutrigenItemNum
            };

            await onAdd(addDto);
        }
    };

    const footer = (
        <div style={{ textAlign: "right" }}>
            <Space>
                <CancelButton onClick={onClose} />
                <FormButton
                    title={isEdit ? "Save" : "Add"}
                    icon={isEdit ? <EditOutlined /> : <PlusOutlined />}
                    onClick={() => {
                        form
                            .validateFields()
                            .then(() => handleSave())
                            .catch(() => { });
                    }}
                />
            </Space>
        </div>
    );


    return (
        <Drawer
            title={isEdit ? 'Edit Nutrigen UPC Link' : 'Add Nutrigen UPC Link'}
            width={420}
            open={open}
            onClose={onClose}
            destroyOnClose
            footer={footer
            }
            styles={{
                header: {
                    color: 'white',
                    backgroundColor: 'var(--color-primary)',
                    fontWeight: 350,
                    fontSize: '14px',
                    border: 0,
                    minHeight: '40px',
                },
            }}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="UPC"
                    name="upc"
                    rules={[
                        { required: true, message: 'UPC is required' },
                        { pattern: /^\d+$/, message: 'UPC must be numeric' }
                    ]}
                >
                    <Input disabled={isEdit} />
                </Form.Item>

                <Form.Item
                    label="Nutrigen Item Number"
                    name="nutrigenItemNum"
                    rules={[
                        { required: true, message: 'Nutrigen item number is required' }
                    ]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default NutrigenUpcLinkDrawer;
